/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DataClipId } from "../../commons/types/DataClipId";
import { SheetId } from "../../commons/types/SheetId";
export const AddRecordsToDataClipJobConfig = core.serialization.object({
    dataClipId: DataClipId,
    sheetId: SheetId,
});
